export default {
  title: 'Chargenwerte löschen',
  confirmDelete: {
    header: 'Werte von "{item}" löschen?',
    message: 'Alle Werte von {from} bis {to} werden gelöscht. Dies kann nicht rückgängig gemacht werden.',
  },
};
